module.exports = __webpack_public_path__ + "static/media/less_common_symptoms.8a12e3e0.svg";